<template>
  <form v-if="sourceInfo">
    <v-text-field
      v-model="sourceInfo.name"
      label="Name"
      outlined
      dense
      required
      :disabled="state.loading || state.saveLoading"
    ></v-text-field>
    <v-text-field
      v-model="sourceInfo.data.businessId"
      label="Business ID"
      outlined
      dense
      required
      :disabled="state.loading || state.saveLoading"
    ></v-text-field>
    <v-text-field
      v-model="sourceInfo.data.apiKey"
      label="API Key"
      outlined
      dense
      required
      type="password"
      :disabled="state.loading || state.saveLoading"
    ></v-text-field>

    <div class="align-center d-flex justify-end flex-column-reverse flex-sm-row flex-wrap">
      <v-btn
        :loading="state.loading"
        variant="elevated"
        color="grey"
        class="mt-4 mt-sm-0 w-100 w-sm-auto"
        :to="URLs.PAGE_CUSTOMER_EDIT(customerId)"
        :disabled="state.saveLoading"
        text="Cancel"
      />
      <v-btn
        :loading="state.saveLoading"
        @click="handleClickSave"
        class="ml-0 ml-sm-2 w-100 w-sm-auto"
        color="primary"
        variant="elevated"
        append-icon="mdi-content-save"
        text="Save"
      />
    </div>
  </form>
  <Loading message="Loading source info..." v-else />
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { IApp } from "@/types";
import { useAccountStore } from "@/stores/account";
import { makeAlert } from "@/utils";
import { URLs } from "@/constants";
import Loading from "../Widgets/Loading.vue";
import useRouteParams from "@/hooks/useRouteParams";
import { useAuthStore } from "@/stores/auth";
const router = useRouter();
const accountStore = useAccountStore();
const authStore = useAuthStore();
const user = computed(() => authStore.user);

const { sourceId, customerId } = useRouteParams();
const sourceInfo = ref<IApp.IBirdEyeAccount>();

const state = ref<{
  businessId?: string;
  apiKey?: string;
  name?: string;
  loading: boolean;
  saveLoading: boolean;
}>({
  loading: false,
  saveLoading: false
});

const fetchAccountInfo = async (customerId: string | undefined, sourceId: string | undefined) => {
  if (sourceId && customerId) {
    state.value.loading = true;
    const response = await accountStore.fetchAccountInfo<IApp.IFeedTypes.BirdEye>(
      user.value?.id!,
      customerId,
      sourceId
    );
    if (response.status) {
      if (response.data.account.feed === IApp.IFeedTypes.BirdEye) {
        sourceInfo.value = response.data.account;
      } else {
        makeAlert("This account is not a BirdEye account", "error");
        state.value.loading = false;
        router.push({
          name: "profile"
        });
      }
    } else {
      makeAlert(response.message, "error");
    }
    state.value.loading = false;
  }
};

const handleClickSave = async () => {
  if (sourceInfo.value && confirm("Are you sure you want to save?")) {
    state.value.saveLoading = true;
    const response = await accountStore.patchAccountInfo(
      user.value?.id!,
      customerId.value!,
      sourceInfo.value.account,
      {
        type: IApp.IFeedTypes.BirdEye,
        name: sourceInfo.value.name,
        apiKey: state.value.apiKey,
        businessId: state.value.businessId
      }
    );
    if (response.status) {
      makeAlert(response.data.message, "success");
    } else {
      makeAlert(response.message, "error");
    }
    state.value.saveLoading = false;
  }
};

onMounted(() => fetchAccountInfo(customerId.value, sourceId.value));
</script>
